import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content using DOMPurify to prevent XSS attacks.
 * Use this function wherever raw HTML must be rendered via dangerouslySetInnerHTML.
 *
 * @param dirty - The untrusted HTML string to sanitize
 * @returns A sanitized HTML string safe for rendering
 */
export const sanitizeHtml = (dirty: string): string => {
    return DOMPurify.sanitize(dirty, {
        ALLOWED_TAGS: [
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'p', 'br', 'hr', 'blockquote', 'pre', 'code',
            'ul', 'ol', 'li',
            'a', 'strong', 'em', 'b', 'i', 'u', 's', 'sub', 'sup',
            'table', 'thead', 'tbody', 'tr', 'th', 'td',
            'div', 'span', 'img',
            'dl', 'dt', 'dd',
        ],
        ALLOWED_ATTR: [
            'href', 'target', 'rel', 'src', 'alt', 'title', 'width', 'height',
            'class', 'id', 'style', 'colspan', 'rowspan', 'align', 'valign',
        ],
        ALLOW_DATA_ATTR: false,
    });
};

